export default /* glsl */ `
#ifdef USE_MAP

    vec4 pinkTex = texture2D(pinkMap, vMapUv);
    vec4 orangeTex = texture2D(orangeMap, vMapUv);

     vec4 mixTex = mix(pinkTex, orangeTex, uMix);

	 diffuseColor *= mixTex;
    //  diffuseColor *= texture2D( map, vMapUv );
#endif
`;
